import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import EcommerceDetails from "./EcommerceDetails";

const EcommerceSinglePage: React.FC = () => {
    useEffect(() => {
                document.title = "AI For E-commerce | Brain Machine AI";
              }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="AI For E-commerce" pagesub="AI For E-commerce" />
                        <EcommerceDetails/>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default EcommerceSinglePage;
